export const resolveDownloadExtension = (filePath = "", blob = null) => {
  const normalizedPath = String(filePath || "").split("?")[0].toLowerCase();
  if (normalizedPath.endsWith(".pdf")) return ".pdf";
  if (normalizedPath.endsWith(".xlsx")) return ".xlsx";
  if (normalizedPath.endsWith(".csv")) return ".csv";
  if (normalizedPath.endsWith(".docx")) return ".docx";
  if (normalizedPath.endsWith(".doc")) return ".doc";

  const mimeType = String(blob?.type || "").toLowerCase();
  if (mimeType.includes("pdf")) return ".pdf";
  if (
    mimeType.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    )
  )
    return ".xlsx";
  if (mimeType.includes("text/csv") || mimeType.includes("csv")) return ".csv";
  if (mimeType.includes("wordprocessingml")) return ".docx";
  if (mimeType.includes("msword")) return ".doc";

  return ".pdf";
};
